import { render, staticRenderFns } from "./ConsequenceModal.vue?vue&type=template&id=7ff5fa17&scoped=true&"
import script from "./ConsequenceModal.vue?vue&type=script&lang=js&"
export * from "./ConsequenceModal.vue?vue&type=script&lang=js&"
import style0 from "./ConsequenceModal.vue?vue&type=style&index=0&id=7ff5fa17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5fa17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff5fa17')) {
      api.createRecord('7ff5fa17', component.options)
    } else {
      api.reload('7ff5fa17', component.options)
    }
    module.hot.accept("./ConsequenceModal.vue?vue&type=template&id=7ff5fa17&scoped=true&", function () {
      api.rerender('7ff5fa17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/ConsequenceModal.vue"
export default component.exports